import React from 'react';
import { Button } from '../ui/Button';
import { PriceDisplay } from '../ui/PriceDisplay';
export function Footer() {
  return <footer className="bg-forest-green text-cream pt-8 pb-6 px-4 border-t-8 border-gold" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <div className="bg-white/5 p-5 md:p-6 rounded-2xl border border-white/10 mb-6 text-left shadow-xl" data-id="element-61">
          <div className="space-y-4" data-id="element-62">
            <div className="border-l-4 border-gold pl-4 md:pl-6" data-id="element-63">
              <p className="text-lg md:text-xl leading-relaxed font-medium" data-id="element-64">
                <strong className="text-gold font-black mr-2 text-xl" data-id="element-65">
                  PD:
                </strong>{' '}
                Recordá que tenés 30 días de garantía total. Si no ves
                resultados, te devuelvo todo. El riesgo es cero. Pero tu peludo
                está esperando este cambio.
              </p>
            </div>

            <div className="h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent my-4" data-id="element-66"></div>

            <div className="border-l-4 border-gold pl-4 md:pl-6" data-id="element-67">
              <p className="text-lg md:text-xl leading-relaxed font-medium" data-id="element-68">
                <strong className="text-gold font-black mr-2 text-xl" data-id="element-69">
                  PD2:
                </strong>{' '}
                Esta oferta de lanzamiento a{' '}
                <span className="font-black text-gold text-xl" data-id="element-70">
                  <PriceDisplay type="offer" data-id="element-71" />
                </span>{' '}
                (en lugar de{' '}
                <span className="line-through opacity-70" data-id="element-72">
                  <PriceDisplay type="regular" data-id="element-73" />
                </span>
                ) puede cerrarse en cualquier momento. Una vez que suba el
                precio, no va a volver a este valor. Si llegaste hasta acá
                leyendo todo esto, sabés que lo necesitás. Actuá ahora.
              </p>
            </div>
          </div>

          <div className="mt-6 text-center" data-id="element-74">
            <Button variant="primary" fullWidth className="md:w-auto shadow-glow" data-id="element-75">
              ▶ SÍ, QUIERO ESTO PARA MI MASCOTA →
            </Button>
          </div>
        </div>

        <div className="text-sm md:text-base text-cream/60 space-y-3 font-medium" data-id="element-76">
          <p data-id="element-77">
            © {new Date().getFullYear()} Alimenta Con Amor. Todos los derechos
            reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-78">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-79">
              Términos y Condiciones
            </a>
            <span className="hidden md:inline opacity-30" data-id="element-80">|</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-81">
              Política de Privacidad
            </a>
            <span className="hidden md:inline opacity-30" data-id="element-82">|</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-83">
              Contacto
            </a>
          </div>
          <p className="text-xs mt-4 max-w-2xl mx-auto opacity-40 leading-relaxed" data-id="element-84">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}